import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { PropertyCreateForm } from '@/routes/dashboard/propertyCreate/PropertyCreateForm';

export function DashboardPropertyCreate(): JSX.Element {
  const navigate = useNavigate();

  return (
    <section className="flex flex-col gap-xl py-8">
      <button
        type="button"
        onClick={() => {
          navigate('/dashboard/properties');
        }}
        className="min-h-11 w-fit rounded-full border border-brand-primary/40 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-brand-primary transition hover:bg-brand-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary"
      >
        Back to properties
      </button>

      <header className="flex flex-col gap-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-brand-primary/70">
          New inventory record
        </p>
        <h1 className="text-3xl font-semibold text-text-primary">Create property</h1>
        <p className="text-sm text-text-primary/70">
          Add a new property to the dashboard. You can upload hero photos, manage units, and adjust
          details after creation.
        </p>
      </header>

      <div className="rounded-3xl border border-surface-subtle bg-white p-6 shadow-sm">
        <PropertyCreateForm
          onCancel={() => {
            navigate('/dashboard/properties');
          }}
          onCreated={(detail, viewDetailsOnCreate) => {
            if (viewDetailsOnCreate) {
              navigate(`/dashboard/properties/${detail.summary.id}`);
            } else {
              navigate('/dashboard/properties');
            }
          }}
        />
      </div>
    </section>
  );
}
